/** Utility functions for adding subtasks, separated from React hook logic. */
import { serverTimestamp } from '@/lib/firebase';

const createAncestorPayload = (ancestor) => {
  const payload = { updatedAt: serverTimestamp(), duration: 0 };
  if (ancestor.time) payload.time = null;
  return payload;
};

const updateAncestors = async (startId, tasksMap, onUpdate, userId) => {
  const visited = new Set();
  let currentId = startId;
  while (currentId && !visited.has(currentId)) {
    visited.add(currentId);
    const ancestor = tasksMap.get(currentId);
    if (!ancestor) break;
    await onUpdate(currentId, createAncestorPayload(ancestor), userId);
    currentId = ancestor.parentId;
  }
};

/**
 * @returns {Promise<string | undefined>}
 */
export const executeSaveSubtask = async (
  parentTask,
  subtaskData,
  allTasks,
  addTask,
  augmentNewTaskWithDefaults,
  tasksMap,
  onUpdate,
  userId,
) => {
  if (!parentTask) return;
  try {
    const inheritedData = {
      projects:
        subtaskData.projects?.length > 0
          ? subtaskData.projects
          : parentTask.projects || [],
      contexts:
        subtaskData.contexts?.length > 0
          ? subtaskData.contexts
          : parentTask.contexts || [],
    };
    const augmented = augmentNewTaskWithDefaults(
      { ...subtaskData, ...inheritedData, parentId: parentTask.id },
      allTasks,
    );
    const taskId = await addTask(augmented);
    // Ancestor duration-reset mag de inline-input niet blokkeren (closeOnSave).
    if (onUpdate) {
      void updateAncestors(parentTask.id, tasksMap, onUpdate, userId).catch(
        (err) => {
          console.error('[executeSaveSubtask] Ancestor update failed:', err);
        },
      );
    }
    return taskId;
  } catch (e) {
    console.error('[executeSaveSubtask] Error:', e);
    throw e;
  }
};
